<template>
  <v-app style="background-color: #f8f9fb">
    <v-divider></v-divider>
    <br /><br />

    <!-- Diálogo de empresa sem telefone cadastrado -->
    <v-dialog v-model="showNoPhoneDialog" persistent max-width="400">
      <v-card>
        <v-card-title> Aviso </v-card-title>
        <v-card-text class="d-flex justify-center text-center">
          <div>
            <p class="mb-2">
              A empresa <strong>{{ empresaSemTelefone }}</strong> não possui
              telefone cadastrado.
            </p>
            <p class="mb-0">Por favor, selecione outra empresa.</p>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showNoPhoneDialog = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #eee" id="filas" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-format-list-bulleted"
            title="Filas"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row style="margin-top: 1rem">
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense
                    solo-inverted
                    v-model="nomeFila"
                    label="Nome da Fila"
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    dense
                    solo-inverted
                    :items="empresasFiltradas"
                    v-model="empresaSelecionada"
                    filled
                    :rules="[
                      (v) =>
                        (v != null && v !== '') || 'Este campo é obrigatório',
                    ]"
                    label="Empresa"
                    @change="onEmpresaChange"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item v-if="telefoneEmpresa">
                        <v-list-item-content>
                          <v-list-item-title class="grey--text">
                            <small>Telefone: {{ telefoneEmpresa }}</small>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="telefoneEmpresa"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row v-if="!empresaSelecionada">
                <v-col cols="12">
                  <v-alert type="info" dense text class="mb-0">
                    Selecione uma empresa para carregar os templates
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-if="empresaSelecionada">
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    dense
                    solo-inverted
                    v-model="departamentoSelecionado"
                    :items="departamentos"
                    label="Departamento"
                    multiple
                    required
                    filled
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-select
                    dense
                    solo-inverted
                    :items="templates"
                    item-text="name"
                    item-value="name"
                    v-model="templateSelecionado"
                    label="Templates do Departamento"
                    :disabled="!templates || templates.length === 0"
                    filled
                    append-outer-icon="mdi-plus"
                    @click:append-outer="adicionarTemplate"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="templatesSelecionados.length > 0">
                <v-col class="d-flex" cols="12" sm="12">
                  <v-card outlined class="pa-3" style="width: 100%">
                    <div class="subtitle-2 font-weight-bold mb-2">
                      Templates do Departamento ({{
                        templatesSelecionados.length
                      }})
                    </div>
                    <v-chip-group column>
                      <v-chip
                        v-for="(tpl, index) in templatesSelecionados"
                        :key="index"
                        class="ma-1"
                        color="primary"
                        text-color="white"
                        close
                        @click:close="removerTemplate(index)"
                      >
                        {{ tpl }}
                      </v-chip>
                    </v-chip-group>
                  </v-card>
                </v-col>
              </v-row>

              <v-row v-if="empresaSelecionada">
                <v-col cols="12">
                  <v-select
                    dense
                    solo-inverted
                    :items="templates"
                    item-text="name"
                    item-value="name"
                    v-model="templateLiberadoSelecionado"
                    label="Templates Liberados para Início do Atendimento"
                    :disabled="!templates || templates.length === 0"
                    filled
                    append-outer-icon="mdi-plus"
                    @click:append-outer="adicionarTemplateLiberado"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="empresaSelecionada">
                <v-col class="d-flex" cols="12" sm="12">
                  <v-card outlined class="pa-3" style="width: 100%">
                    <div class="subtitle-2 font-weight-bold mb-2">
                      Templates Liberados para Início do Atendimento ({{
                        templatesLiberadosSelecionados.length
                      }})
                    </div>
                    <div class="caption grey--text text--darken-1 mb-2">
                      Apenas os templates presentes nesta lista serão exibidos ao
                      iniciar um atendimento utilizando esta fila.
                    </div>
                    <v-chip-group
                      v-if="templatesLiberadosSelecionados.length > 0"
                      column
                    >
                      <v-chip
                        v-for="(tpl, index) in templatesLiberadosSelecionados"
                        :key="index"
                        class="ma-1"
                        color="success"
                        text-color="white"
                        close
                        @click:close="removerTemplateLiberado(index)"
                      >
                        {{ tpl }}
                      </v-chip>
                    </v-chip-group>
                    <v-alert v-else dense text type="info" class="mb-0">
                      Nenhum template liberado para início de atendimento.
                    </v-alert>
                  </v-card>
                </v-col>
              </v-row>

              <v-card-actions class="d-flex justify-end">
                <v-btn
                  v-if="filaEditandoId"
                  color="grey"
                  @click="cancelarEdicao"
                  class="mr-2"
                >
                  <v-icon left>mdi-close</v-icon> Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="salvando"
                  :disabled="!podeSalvar"
                  @click="salvarFila"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  {{ filaEditandoId ? "Atualizar" : "Salvar" }}
                </v-btn>
              </v-card-actions>
            </v-form>

            <v-data-table
              style="margin-top: 1rem"
              :headers="filas_header"
              :items="listaFilas"
              :items-per-page="50"
              items-per-page-text="Linhas por página"
              class="elevation-0"
            >
              <template v-slot:top>
                <v-progress-linear
                  v-if="carregandoFilas"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td class="linha" style="width: 10%; font-size: 14px">
                    {{ row.item.id }}
                  </td>

                  <td class="linha" style="width: 20%; font-size: 14px">
                    {{ row.item.nomeFila }}
                  </td>

                  <td class="linha" style="width: 18%; font-size: 14px">
                    {{ row.item.empresa }}
                  </td>

                  <td class="linha" style="width: 40%; font-size: 14px">
                    <v-chip
                      v-for="(template, index) in row.item.templates"
                      :key="index"
                      x-small
                      class="ma-1"
                      color="primary"
                      text-color="white"
                    >
                      {{ template }}
                    </v-chip>
                  </td>

                  <td class="linha" style="width: 25%; font-size: 14px">
                    <v-chip
                      v-for="(template, index) in row.item.templatesLiberados"
                      :key="index"
                      x-small
                      class="ma-1"
                      color="success"
                      text-color="white"
                    >
                      {{ template }}
                    </v-chip>
                    <span
                      v-if="
                        !row.item.templatesLiberados ||
                        row.item.templatesLiberados.length === 0
                      "
                      class="grey--text caption"
                    >
                      Nenhum
                    </span>
                  </td>

                  <td class="linha" style="width: 12%; font-size: 14px">
                    <v-btn
                      @click="editarFila(row.item)"
                      fab
                      small
                      color="primary"
                      class="mr-2"
                      title="Editar fila"
                    >
                      <v-icon dark> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      @click="deletarFila(row.item.id)"
                      fab
                      small
                      color="error"
                      title="Excluir fila"
                    >
                      <v-icon dark> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Sonax from "@/services/sonax";
import Wazzup from "@/services/wazzup";

export default {
  name: "Filas",
  mounted() {
    this.carregarListaFilas();
  },
  data() {
    return {
      rules: {
        required: (v) => !!v || "Obrigatório.",
      },
      valid: true,
      showNoPhoneDialog: false,
      empresaSemTelefone: "",

      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ],
      empresaSelecionada: "",
      telefoneEmpresa: "",

      nomeFila: "",
      templates: [],
      templateSelecionado: null,
      templateLiberadoSelecionado: null,
      departamentoSelecionado: null,
      templatesSelecionados: [],
      templatesLiberadosSelecionados: [],
      filaEditandoId: null,
      departamentos: [
        "ADMINISTRAÇÃO E ATENDIMENTO",
        "ADMINISTRATIVO",
        "ADMINISTRATIVO/FINANCEIRO",
        "CALL CENTER",
        "CALL CENTER - VENDAS",
        "CALL CENTER - COBRANÇA",
        "COMERCIAL",
        "CORPORATIVO",
        "DIRETORIA",
        "FATURAMENTO",
        "FINANCEIRO",
        "FLORICULTURA",
        "LANCHONETE",
        "LOGISTICA E MANUTENCAO",
        "MANUTENÇÃO",
        "OPERAÇÕES",
        "RECURSOS HUMANO",
        "RECURSOS HUMANOS",
        "REGULACAO SEGURO",
        "RELACIONAMENTO AO CLIENTE",
        "SAC - SERVICO DE ATENDIMENTO AO CONSUMIDOR",
        "SEPULTAMENTO",
        "SERVICOS FUNERARIOS",
        "TESOURARIA",
        "VENDAS",
      ],
      salvando: false,

      listaFilas: [],
      carregandoFilas: false,
      filas_header: [
        { text: "ID", value: "id" },
        { text: "Nome da Fila", value: "nomeFila" },
        { text: "Empresa", value: "empresa" },
        { text: "Templates", value: "templates" },
        { text: "Templates Liberados", value: "templatesLiberados" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    empresasFiltradas() {
      // Filtra as empresas com base nas permissões do usuário
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    podeSalvar() {
      return (
        this.nomeFila &&
        this.empresaSelecionada &&
        this.templatesSelecionados.length > 0 &&
        !this.salvando
      );
    },
  },
  methods: {
    hasPermission(empresa) {
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (!user || !user.roles) return false;

      if (user.roles.includes("ROLE_ADMIN")) {
        return true;
      }

      const requiredRoles = empresa
        .split(" ")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => user.roles.includes(role));
    },

    verificarTelefoneEmpresa(empresa) {
      if (!empresa || empresa === "Todas") {
        return "558282308177"; // Padrão (Previda)
      }

      // Mapeamento de empresa para telefone
      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
        "A FLOR DO CAFÉ": "558000829000",
      };

      // Função para normalizar string (remove acentos e converte para maiúscula)
      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      // Tenta encontrar correspondência exata primeiro
      if (mapeamentoEmpresas[empresa]) {
        return mapeamentoEmpresas[empresa];
      }

      // Tenta com uppercase
      const empresaUpper = empresa.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      // Tenta com normalização (sem acentos)
      const empresaNormalizada = normalizar(empresa);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      // Se não encontrou, verifica se contém palavras-chave
      // Empresas de cemitério não possuem telefone de WhatsApp cadastrado
      if (empresaNormalizada.includes("CEMITERIO")) {
        return null;
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      // Retorna null se não encontrou correspondência
      return null;
    },

    onEmpresaChange() {
      if (!this.empresaSelecionada) {
        this.telefoneEmpresa = "";
        this.templates = [];
        return;
      }

      const telefone = this.verificarTelefoneEmpresa(this.empresaSelecionada);
      if (!telefone) {
        this.empresaSemTelefone = this.empresaSelecionada;
        this.telefoneEmpresa = "";
        this.templates = [];
        this.showNoPhoneDialog = true;
        // Limpa a seleção se não tiver telefone
        this.$nextTick(() => {
          this.empresaSelecionada = "";
        });
        return;
      }

      this.telefoneEmpresa = telefone;
      this.carregarTemplates();
    },

    async carregarTemplates() {
      if (!this.telefoneEmpresa) {
        this.templates = [];
        return;
      }

      // Inicializa o array de templates
      let templatesSonax = [];
      let templatesWazzup = [];

      try {
        // 1. Carregar templates do Sonax
        const respSonax = await Sonax.getTemplates(this.telefoneEmpresa);

        if (
          respSonax.data &&
          !respSonax.data.error &&
          respSonax.data.data &&
          respSonax.data.data.brokers &&
          respSonax.data.data.brokers.length > 0
        ) {
          // Procurar o broker que corresponde ao telefoneEmpresa usado na requisição
          let brokerEncontrado = respSonax.data.data.brokers.find(
            (broker) => broker.number === this.telefoneEmpresa,
          );

          // Se não encontrar o broker específico, pegar o primeiro broker que tenha templates
          if (
            !brokerEncontrado ||
            !brokerEncontrado.templates ||
            brokerEncontrado.templates.length === 0
          ) {
            brokerEncontrado = respSonax.data.data.brokers.find(
              (broker) => broker.templates && broker.templates.length > 0,
            );
          }

          // Se encontrou um broker com templates, extrair os templates
          if (
            brokerEncontrado &&
            brokerEncontrado.templates &&
            brokerEncontrado.templates.length > 0
          ) {
            const brokerNumber = brokerEncontrado.number;
            // Adicionar origem e número do broker a cada template
            templatesSonax = brokerEncontrado.templates.map((template) => ({
              ...template,
              brokerNumber,
              origem: "SONAX",
            }));
            console.log("Templates Sonax carregados:", templatesSonax.length);
          } else {
            console.log(
              "Nenhum template Sonax encontrado para o telefone:",
              this.telefoneEmpresa,
            );
          }
        }
      } catch (e) {
        console.error("Erro ao carregar templates do Sonax:", e);
      }

      try {
        // 2. Carregar templates do Wazzup
        if (this.empresaSelecionada) {
          const respWazzup = await Wazzup.listarTemplates(
            this.empresaSelecionada,
          );
          if (respWazzup && respWazzup.data && Array.isArray(respWazzup.data)) {
            // Mapeia os templates do Wazzup para o formato esperado
            templatesWazzup = respWazzup.data.map((template) => ({
              id: template.id,
              name: template.nome,
              text: template.texto,
              empresa: template.empresa,
              inicio: template.inicio,
              ura: template.ura,
              origem: "WAZZUP",
            }));
          } else if (
            respWazzup &&
            respWazzup.data &&
            respWazzup.data.data &&
            Array.isArray(respWazzup.data.data)
          ) {
            // Estrutura alternativa
            templatesWazzup = respWazzup.data.data.map((template) => ({
              id: template.id,
              name: template.nome,
              text: template.texto,
              empresa: template.empresa,
              inicio: template.inicio,
              ura: template.ura,
              origem: "WAZZUP",
            }));
          }
        }
      } catch (e) {
        console.error("Erro ao carregar templates do Wazzup:", e);
      }

      // Combina os templates de ambas as fontes
      this.templates = [...templatesSonax, ...templatesWazzup];
      console.log("Templates carregados:", this.templates);
    },

    adicionarTemplate() {
      if (
        this.templateSelecionado &&
        !this.templatesSelecionados.includes(this.templateSelecionado)
      ) {
        this.templatesSelecionados.push(this.templateSelecionado);
        this.templateSelecionado = null; // Limpa a seleção após adicionar
      }
    },

    removerTemplate(index) {
      this.templatesSelecionados.splice(index, 1);
    },

    adicionarTemplateLiberado() {
      if (
        this.templateLiberadoSelecionado &&
        !this.templatesLiberadosSelecionados.includes(
          this.templateLiberadoSelecionado,
        )
      ) {
        this.templatesLiberadosSelecionados.push(
          this.templateLiberadoSelecionado,
        );
        this.templateLiberadoSelecionado = null;
      }
    },

    removerTemplateLiberado(index) {
      this.templatesLiberadosSelecionados.splice(index, 1);
    },

    salvarFila() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (!this.podeSalvar) {
        return;
      }

      this.salvando = true;

      const payload = {
        id: this.filaEditandoId,
        nomeFila: this.nomeFila,
        empresa: this.empresaSelecionada,
        templates: this.templatesSelecionados,
        templatesLiberados: this.templatesLiberadosSelecionados,
        departamentos: this.departamentoSelecionado,
      };

      Sonax.salvarFilaTemplate(payload)
        .then(() => {
          const mensagem = this.filaEditandoId
            ? "Fila atualizada com sucesso!"
            : "Fila salva com sucesso!";
          this.$toast &&
            this.$toast.success(mensagem, {
              timeout: 3000,
            });
          // Limpa o formulário
          this.limparFormulario();
          // Recarrega a lista de filas
          this.carregarListaFilas();
        })
        .catch((e) => {
          const msg =
            (e.response && e.response.data && e.response.data.error) ||
            e.message ||
            "Erro ao salvar fila.";
          if (this.$toast) {
            this.$toast.error(msg, { timeout: 5000 });
          } else {
            alert(msg);
          }
        })
        .finally(() => {
          this.salvando = false;
        });
    },

    editarFila(fila) {
      // Preenche o formulário com os dados da fila
      this.filaEditandoId = fila.id;
      this.nomeFila = fila.nomeFila;
      this.empresaSelecionada = fila.empresa;
      this.templatesSelecionados = [...(fila.templates || [])];
      this.templatesLiberadosSelecionados = [
        ...(fila.templatesLiberados || []),
      ];
      this.departamentoSelecionado = fila.departamentos || [];

      // Busca o telefone da empresa para carregar os templates disponíveis
      const telefone = this.verificarTelefoneEmpresa(fila.empresa);
      if (telefone) {
        this.telefoneEmpresa = telefone;
        this.carregarTemplates();
      }

      // Scroll suave até o formulário
      this.$nextTick(() => {
        const formElement = document.getElementById("filas");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    cancelarEdicao() {
      this.limparFormulario();
    },

    limparFormulario() {
      this.filaEditandoId = null;
      this.nomeFila = "";
      this.empresaSelecionada = "";
      this.telefoneEmpresa = "";
      this.templateSelecionado = null;
      this.templateLiberadoSelecionado = null;
      this.templatesSelecionados = [];
      this.templatesLiberadosSelecionados = [];
      this.departamentoSelecionado = [];
      this.templates = [];
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    carregarListaFilas() {
      this.carregandoFilas = true;
      Sonax.listarFilaTemplates()
        .then((resp) => {
          if (resp && resp.status === 200 && resp.data) {
            // A resposta pode vir como array direto ou dentro de um objeto
            if (Array.isArray(resp.data)) {
              this.listaFilas = resp.data;
            } else if (resp.data.data && Array.isArray(resp.data.data)) {
              this.listaFilas = resp.data.data;
            } else {
              this.listaFilas = [];
            }
          } else {
            this.listaFilas = [];
          }
        })
        .catch((e) => {
          console.error("Erro ao carregar lista de filas:", e);
          this.listaFilas = [];
        })
        .finally(() => {
          this.carregandoFilas = false;
        });
    },

    deletarFila(id) {
      if (!confirm("Deseja realmente excluir esta fila?")) {
        return;
      }

      // Nota: Se o backend tiver um endpoint DELETE, adicione aqui
      // Por enquanto, vamos apenas recarregar a lista
      // Sonax.deletarFilaTemplate(id)
      //   .then(() => {
      //     this.$toast && this.$toast.success("Fila excluída com sucesso!");
      //     this.carregarListaFilas();
      //   })
      //   .catch((e) => {
      //     const msg = e.response?.data?.error || e.message || "Erro ao excluir fila.";
      //     if (this.$toast) {
      //       this.$toast.error(msg, { timeout: 5000 });
      //     } else {
      //       alert(msg);
      //     }
      //   });

      // Temporário: apenas mostra mensagem
      alert(
        "Funcionalidade de exclusão será implementada quando o endpoint DELETE estiver disponível.",
      );
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.justify-center {
  justify-content: center;
}

.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important;
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
</style>
